module.exports = __webpack_public_path__ + "img/maker_minji.5f0de788.png";